import React, { useState } from 'react'
import { Link } from "react-router-dom";


const Hadear = () => {
  const [toggle, setToggle] = useState(false);

  const CloseClick = () => {
    setToggle(false);

  };
  return (
    <>


      <header className="header-area header-one">
        {/*====  Header Navigation  ===*/}
        <div className="container-fluid">
          <div className="header-navigation">
            {/*====  Primary Menu  ===*/}
            <div className="primary-menu">
              {/*====  Site Branding  ===*/}
              <div className="site-branding">
                <Link to="/" className="brand-logo"><img src="assets/img/Earth_1.webp" alt="Brand Logo" /></Link>
              </div>
              {/*=== Main Menu ===*/}
              <div className="theme-nav-menu">
                {/*=== Menu Top ===*/}
                <div className="theme-menu-top d-block d-xl-none">
                  <div className="site-branding">
                    <Link to="/" className="brand-logo"><img src="assets/img/Earth_1.webp" alt="Brand Logo" /></Link>
                  </div>
                </div>
                {/*=== Main Menu ===*/}
                <nav className="main-menu">
                  <ul>
                    
                    <li className="menu-item"><Link to="/">Home</Link></li>
                    <li className="menu-item"><Link to="about-us">About Us</Link></li>
                    <li className="menu-item has-children"><a to="#">Our Projects<span className="dd-trigger"><i className="far fa-angle-down" /></span></a>
                      <ul className="sub-menu">
                        <li><a to="projects.html">Current Projects</a></li>
                        <li><a to="project-details.html">Ongoing Projects</a></li>
                        <li><a to="project-details.html">Complete Projects</a></li>
                      </ul>
                    </li>
                    <li className="menu-item has-children"><a to="#">Our Division<span className="dd-trigger"><i className="far fa-angle-down" /></span></a>
                      <ul className="sub-menu">
                        <li><a to="projects.html">Residential Property</a></li>
                        <li><a to="project-details.html">Commercial Property</a></li>
                      </ul>
                    </li>
                    <li className="menu-item"><Link to="our-gallery">Our Gallery</Link></li>
                    <li className="menu-item"><Link to="clientele">Clientele</Link></li>
                    <li className="menu-item"><Link to="contact-us">Contact Us</Link></li>
                  </ul>
                </nav>
                {/*=== Nav Button ===*/}
                <div className="theme-nav-button mt-20 d-block d-md-none">
                  <Link to="contact-us" className="theme-btn style-one">Get Started<i className="far fa-arrow-right" /></Link>
                </div>
                {/*===  Menu Bottom ===*/}
                <div className="theme-menu-bottom mt-50 d-block d-xl-none">
                  <h5>Follow Us</h5>
                  <ul className="social-link">
                    <li><Link to="https://www.facebook.com/earthbondproperty/?ref=NONE_xav_ig_profile_page_web#" target='_blank'><i className="fab fa-facebook-f" /></Link></li>
                    <li><Link to="https://www.instagram.com/earth_bond_property/" target='_blank'><i className="fab fa-linkedin-in" /></Link></li>
                    <li><Link to="https://www.youtube.com/@earthbondproperty"><i className="fab fa-youtube" target='_blank' /></Link></li>
                  </ul>
                </div>
              </div>
              {/*=== Header Nav Right ===*/}
              <div className="nav-right-item">
                <div className="nav-button d-none d-md-block">
                  <a to="contact.html" className="theme-btn style-one">Get Started<i className="far fa-arrow-right" /></a>
                </div>
                
                <div className="navbar-toggler">
                  <span />
                  <span />
                  <span />
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>





    </>
  )
}

export default Hadear